export default {
  install: (app, options = {
    key: "6LeGb3wqAAAAAA-UFOu1o1f1wjHTBj8vFFhALYMT",
    hide: false
  }) => {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${options.key}`);
    document.head.appendChild(recaptchaScript);

    if (options.hide) {
      const recaptchaStyle = document.createElement('style');
      recaptchaStyle.innerHTML = '.grecaptcha-badge { visibility: hidden; }';
      document.head.appendChild(recaptchaStyle);
    }

    const execute = () => {
      return new Promise((resolve, reject) => {
        grecaptcha.execute(options.key, { action: 'submit' })
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error);
          });
      })
    };

    const recaptcha = { execute };

    app.config.globalProperties.$recaptcha = recaptcha;
    app.provide('$recaptcha', recaptcha);
  }
}